// @core/api/endpoints/booking/list_waitlist_entries.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListWaitlistEntriesResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * List waitlist entries
 * Returns waitlist entries for a resource, ordered by position.
 */
export async function ListWaitlistEntries(
  resource_id: string,
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListWaitlistEntriesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_id/waitlist`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.get<ListWaitlistEntriesResponse>(requestPath, { ...requestOptions, params });
}
